import { render, staticRenderFns } from "./quesSuccess2_1.vue?vue&type=template&id=2364a8ac"
import script from "./quesSuccess2_1.vue?vue&type=script&lang=js"
export * from "./quesSuccess2_1.vue?vue&type=script&lang=js"
import style0 from "./quesSuccess2_1.vue?vue&type=style&index=0&id=2364a8ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports